import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ConsultationSteps } from './components/ConsultationSteps';
import { PainProblem } from './components/PainProblem';
import { WhatWeInstall } from './components/WhatWeInstall';
import { Framework } from './components/Framework';
import { Results } from './components/Results';
import { HelpFirst } from './components/HelpFirst';
import { Guarantee } from './components/Guarantee';
import { Packages } from './components/Packages';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col w-full bg-off-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <ConsultationSteps data-id="element-4" />
        <PainProblem data-id="element-5" />
        <WhatWeInstall data-id="element-6" />
        <Framework data-id="element-7" />
        <Results data-id="element-8" />
        <HelpFirst data-id="element-9" />
        <Guarantee data-id="element-10" />
        <Packages data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}